import script from "./DateTimeHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./DateTimeHeader.vue?vue&type=script&setup=true&lang=js"

import "./DateTimeHeader.vue?vue&type=style&index=0&id=9ff8e38a&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9ff8e38a"]])

export default __exports__